// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"498":"reservations","699":"region-detail","953":"villa-detail"}[chunkId] + "." + {"498":"c52c74a1","699":"1e01369c","953":"04475a01"}[chunkId] + ".chunk.css";
};